/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ContactToolPage = lazyLoad(
  () => import('./index'),
  module => module.ContactToolPage
);
